import styled from "@emotion/styled";
import PersonIcon from "@mui/icons-material/Person";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { useEffect, useState } from "react";
import { HorizontalGap } from "../styled/gaps";
import { useLocation } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
`;

const HeaderTitle = styled.div`
  color: #1f192f;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const UserProfile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const Username = styled.div`
  color: #2e2e2e;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
const getTitle = (pathname) => {
  switch (pathname) {
    case "/services":
      return "Services";
    case "/dashboard":
      return "Dashboard";
    case "/business":
    case "/business/profile":
    case "/business/timings":
    case "/business/holidays":
      return "Business Info";
    case "/help":
      return "Help";
    default:
      return "Something went wrong";
  }
};
const MainHeader = (props) => {
  const location = useLocation();
  const [pageName, setPageName] = useState(getTitle(location.pathname));

  useEffect(() => {
    // debugger;
    setPageName(getTitle(location.pathname));
  }, [location.pathname]);

  return (
    <Container>
      <HeaderTitle>{pageName}</HeaderTitle>
      <UserProfile>
        <PersonIcon></PersonIcon>
        <HorizontalGap size={"10px"} />
        <Username>User Name</Username>
        <HorizontalGap size={"10px"} />
        <ArrowDropDownIcon></ArrowDropDownIcon>
      </UserProfile>
    </Container>
  );
};

export { MainHeader };
